module.exports = __webpack_public_path__ + "../resources/img/ic_re_server_setting_glass_img.8de827b8.svg";